export function useScrollToElement() {
  const scrollToElement = (elementId: string) => {
    const element = document.getElementById(elementId);

    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    } else {
      console.error("Element not found");
    }
  };

  return { scrollToElement };
}
